import { NavLink, Outlet, useLocation } from "react-router-dom";
import { Home as HomeIcon, PiggyBank, Vault as VaultIcon, LineChart, Users } from "lucide-react";
import { cn } from "@/lib/utils";

const nav = [
  { to: "/home", label: "Home", icon: HomeIcon, tid: "nav-home" },
  { to: "/save", label: "Save", icon: PiggyBank, tid: "nav-save" },
  { to: "/vault", label: "Vault", icon: VaultIcon, tid: "nav-vault" },
  { to: "/market", label: "Market", icon: LineChart, tid: "nav-market" },
  { to: "/circle", label: "Circle", icon: Users, tid: "nav-circle" },
];

export default function AppShell() {
  const { pathname } = useLocation();
  return (
    <div className="bg-paper min-h-screen">
      <div className="mx-auto max-w-md pb-28 pt-2">
        <main data-testid="app-main" className="px-5 animate-fade-up">
          <Outlet />
        </main>
      </div>

      <nav
        data-testid="bottom-nav"
        className="fixed bottom-3 left-1/2 -translate-x-1/2 z-40 w-[92%] max-w-md"
      >
        <div className="mx-auto rounded-full border border-brand-line bg-brand-ivory/95 backdrop-blur shadow-card px-2 py-2 flex items-center justify-between">
          {nav.map(({ to, label, icon: Icon, tid }) => {
            const active = pathname === to;
            return (
              <NavLink
                key={to}
                to={to}
                data-testid={tid}
                className={cn(
                  "flex-1 flex flex-col items-center gap-0.5 py-1.5 rounded-full transition-transform duration-200",
                  "active:scale-95"
                )}
              >
                <div
                  className={cn(
                    "flex items-center justify-center h-9 w-9 rounded-full",
                    active ? "bg-brand-primary text-brand-ivory shadow-card" : "text-brand-slate"
                  )}
                >
                  <Icon size={18} strokeWidth={2} />
                </div>
                <span
                  className={cn(
                    "text-[10px] font-semibold tracking-wide",
                    active ? "text-brand-primary" : "text-brand-slate"
                  )}
                >
                  {label}
                </span>
              </NavLink>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
